module.exports = __webpack_public_path__ + "img/ic_you@2x.7a29b7d4.png";